module.exports = __webpack_public_path__ + "images/icon/icn_searchhelp_16x16-e48908ab.svg";